import { BaseService } from "./BaseService";
import { StateService } from "@uirouter/angularjs";
import { Company } from "../entities/Company";

export class CompanyService extends BaseService<Company>{
    static $inject = ['$http', '$q', '$state', 'localStorageService'];
    static APPSETTINGSKEY: string = "LOCSTORAGEAPPSETTINGS";
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Company);
    }
    protected getBaseUrl(): string {
        return "company";
    }    
    protected getBasesUrl(): string {
        return "companies";
    }    
}
